import { ArrowDropDown } from "@mui/icons-material"
import { Checkbox, Grid, Paper, Typography } from "@mui/material"
import { Button, CompactTable, StyledPaper } from "../commons"
import { BorrowAndLendingDataType, constructBorrowAndLendingTableMobile } from "./table"
import { useNavigate } from "react-router-dom"
import { useState } from "react"

export interface BorrowAndLendingTableType {
  tabs: string[],
  data: BorrowAndLendingDataType[]
}

const HideAsset = (props: { callback: () => void }) => {
  return (
    <>
      <Checkbox sx={{ paddingLeft: 0 }} onChange={() => props.callback()} />
      <Typography variant="r" color='text.primary' sx={{ verticalAlign: 'middle' }}>
        {'Hide Assets (< $1)'}
      </Typography>
    </>
  )
}

// const EModeOption = () => {
//   return (
//     <>
//       <Typography variant="r" color='text.primary' sx={{ verticalAlign: 'middle' }}>
//         {'E-Mode'}
//       </Typography>
//       <Checkbox />
//     </>
//   )
// }

const BorrowAndLendingTable = (props: BorrowAndLendingTableType) => {
  const { tabs, data } = props
  const [selectedTab, setSelectedTab] = useState(0)
  const [hideSmallAssets, setHideSmallAssets] = useState(false)
  const navigate = useNavigate()
  const isDeposited = selectedTab === 0
  const isBorrowed = selectedTab === 1

  const handleHideSmallAmount = () => {
    setHideSmallAssets((prev) => !prev)
  }

  const optionUI = isDeposited ? <Grid container justifyContent={'flex-start'} alignItems={'flex-start'} flexDirection={'column'}>
    <Grid item> <HideAsset callback={handleHideSmallAmount} /> </Grid>
    <Button transparent sx={{ backgroundColor: 'background.translucent' }}>
      <div style={{ display: 'flex', placeItems: 'center', padding: '0rem 0rem 0rem 0.5rem', gap: '0.5rem' }}>
        <Typography variant="s">Sort: Asset</Typography> <ArrowDropDown sx={{ marginLeft: 'auto' }} />
      </div>
    </Button>
  </Grid> : <div style={{ height: '2.5rem' }} />

  const filteredData = data.filter((data) => hideSmallAssets ? data.supplyValue >= 1 : true)
  const tableBorrowAndLendingData = constructBorrowAndLendingTableMobile(filteredData, isDeposited, isBorrowed, navigate)

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '12.8rem',
        width: '100%',
        borderRadius: 1,
        padding: '0px', //to show border
      }}>
        <Grid container flexDirection={'column'}>
          <Grid container item>
            {
              tabs.map((tab, index) => {
                const isSelected = index === selectedTab
                const isFirst = index === 0
                const isLast = index === tabs.length - 1
                const opacity = isSelected ? 0.24 : 0.12
                return (
                  <Grid item xs={6}>
                    <Button
                      onClick={() => setSelectedTab(index)}
                      sx={{
                        border: 0, borderRadius: isFirst ? '8px 0px 0px 0px' : isLast ? '0px 8px 0px 0px' : 0,
                        background: `rgb(255,255,255,${opacity})`,
                        width: '100%',
                        '&:hover': {
                          background: `rgb(255,255,255,${opacity})`,
                        }
                      }}>
                      <Typography variant="r" color='text.primary' key={index}>
                        {tab}
                      </Typography>
                    </Button>
                  </Grid>
                )
              }
              )
            }
          </Grid>
          <Paper sx={{
            padding: '0.5rem 0rem',
            width: '100%'
          }}>
            <Grid container alignItems={'center'}
              justifyContent={'flex-start'}>
              <Grid item justifyItems={'flex-start'} sx={{ padding: '0rem 1rem' }}>
                {optionUI}
              </Grid>
              <Grid item sx={{ marginTop: 1.5 }}>
                <CompactTable tableContent={tableBorrowAndLendingData} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default BorrowAndLendingTable